import {GAMMA_ZAZ, PROD_ZAZ, STAGES} from "src/utils/constants";

const authConfig = require('../authentication/AuthConfig');

export const getStage = () => {
    const hostName = window.location.hostname;
    const root = hostName.split(".")[0];

    if(hostName.includes(GAMMA_ZAZ)) {
        return "gamma-zaz";
    } else if(hostName.includes(PROD_ZAZ)){
        return "prod-zaz"
    } else if (STAGES.includes(root)) {
        return root;
    }
    return "beta";
};

const stage: any = getStage();
const authStageData = authConfig.auth_stages[stage];

const getApiGatewayStage = (stage: string): string => {
    if (stage === "gamma-zaz") {
        return "gamma";
    } else if(stage === "prod-zaz") {
        return "prod";
    }
    return stage;
};

//Change the stage in below URL to beta for local testing.
export const getApiGatewayBaseURL = `https://${authStageData.apiGatewayEndpointBaseIdentifier}.execute-api.${authStageData.region}.amazonaws.com/${getApiGatewayStage(stage)}`
